const Footer = () => {
	return (
		<footer>
			<div className="wrapper">
				<p>
					Created at <a href="https://junocollege.com/">Juno College of Technology</a> &copy; 2022 by{" "}
					<a href="https://github.com/Pacoromo" target="_blank" rel="noreferrer">
						Paco Romo,
					</a>{" "}
					<a href="https://github.com/GregCrutchlow" target="_blank" rel="noreferrer">
						Greg Crutchlow,
					</a>{" "}
					<a href="https://github.com/Louistam888" target="_blank" rel="noreferrer">
						Louis Tam
					</a>
					, and{" "}
					<a href="https://github.com/myboyblue519" target="_blank" rel="noreferrer">
						Matthew Van Luxemborg
					</a>
				</p>
			</div>
		</footer>
	)
}

export default Footer;